export default "__VITE_ASSET__2FX5Tosj__"